import { render, staticRenderFns } from "./CustomSigningDocumentBuilder.vue?vue&type=template&id=0fa56284&scoped=true&"
import script from "./CustomSigningDocumentBuilder.vue?vue&type=script&lang=ts&"
export * from "./CustomSigningDocumentBuilder.vue?vue&type=script&lang=ts&"
import style0 from "./CustomSigningDocumentBuilder.vue?vue&type=style&index=0&id=0fa56284&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fa56284",
  null
  
)

export default component.exports